var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Layout, Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import DataForm from '~/components/common/data-form.vue';
import DataBox from '~/components/common/data-box.vue';
import ReportcaseManagePending from '~/components/assistant-manage/reportcase-manage/reportcase-manage-pending.vue';
import ReportcaseManageResolve from '~/components/assistant-manage/reportcase-manage/reportcase-manage-resolve.vue';
import ReportcaseManageHandled from '~/components/assistant-manage/reportcase-manage/reportcase-manage-handled.vue';
import FollowRecord from '~/components/approval-manage/follow-record.vue';
import ProcessApprove from '~/components/assistant-manage/process-approve.vue';
import AddNote from '~/components/assistant-manage/reportcase-manage/add-note.vue';
import CheckNote from '~/components/assistant-manage/reportcase-manage/check-note.vue';
import CommonFileUpload from '~/components/assistant-manage/common-file-upload.vue';
import PrincipalBatch from "~/components/common-business/principal-batch.vue";
import { ApprovalExportManageService } from '~/services/dataimp-service/approval-export-manage.service.ts';
var ReportcaseManage = /** @class */ (function (_super) {
    __extends(ReportcaseManage, _super);
    function ReportcaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.reportcaseModel = {
            principalName: '',
            batchNumber: '',
            personalName: '',
            applyRealName: "",
            certificateNo: "",
            applyDate: [],
            caseNumber: ""
        };
        _this.rules = {
            certificateNo: [{
                    min: 4,
                    message: '请输入至少4位的身份证号',
                    trigger: 'blur'
                }]
        };
        _this.approvalCommitLoading = false;
        // 默认激活页面
        _this.activeName = 'pending-operate';
        _this.approvalRules = {
            result: [{
                    required: true,
                    message: '请选择审批结果',
                    trigger: 'change'
                }],
        };
        _this.assistDataSet = null;
        _this.assistObj = {};
        _this.dialog = {
            approvedialog: false,
            addnote: false,
            checknote: false,
            caseImport: false,
        };
        _this.reportcaseRowData = {};
        _this.addNoteRowData = {};
        _this.checkNoteRowData = {};
        return _this;
    }
    ReportcaseManage.prototype.handleResetForm = function () {
        this.reportcaseModel.principalId = '';
    };
    ReportcaseManage.prototype.deactivated = function () {
        for (var v in this.dialog) {
            this.dialog[v] = false;
        }
    };
    ReportcaseManage.prototype.mounted = function () {
        this.refreshData();
    };
    //切换tab页面刷新对应的页面
    ReportcaseManage.prototype.handleTabClick = function (tab, event) {
        this.activeName = tab.name;
        this.resetSearchFelid();
        this.refreshData();
    };
    //刷新数据
    ReportcaseManage.prototype.refreshData = function () {
        var tabdom = this.$refs[this.activeName];
        if (tabdom) {
            tabdom.refreshData();
        }
    };
    //弹出框
    ReportcaseManage.prototype.approvedMeth = function (rowdata) {
        this.dialog.approvedialog = true;
        this.reportcaseRowData = rowdata;
    };
    //添加批注的方法
    ReportcaseManage.prototype.addNoteMeth = function (rowdata) {
        this.dialog.addnote = true;
        this.addNoteRowData = rowdata;
    };
    //查看批注的方法
    ReportcaseManage.prototype.checkNoteMeth = function (rowdata) {
        this.dialog.checknote = true;
        this.checkNoteRowData = rowdata;
    };
    ReportcaseManage.prototype.batchOperation = function () {
        var tabdom = this.$refs[this.activeName];
        var selectedList = tabdom.reportcaseselectionList;
        if (selectedList.length === 0) {
            this.$message('请选择案件！');
            return false;
        }
        else {
            this.reportcaseRowData = selectedList;
            this.dialog.approvedialog = true;
        }
    };
    //reset搜索框
    ReportcaseManage.prototype.resetSearchFelid = function () {
        this.reportcaseModel = {
            principalName: '',
            batchNumber: '',
            personalName: '',
            applyRealName: "",
            certificateNo: "",
            applyDate: []
        };
    };
    ReportcaseManage.prototype.exportCase = function () {
        var _this = this;
        var pendingOperate = this.$refs['pending-operate'];
        if (pendingOperate.selectionList.length == 0) {
            this.$message('请选择要导出的案件!');
            return;
        }
        var processApplicationIds = pendingOperate.selectionList.map(function (v) { return v.processApplicationId; });
        var exportModel = {
            flowType: 'REPORT_CASE_APPLY',
            processApplicationIds: processApplicationIds
        };
        this.$confirm('您确定要导出所选案件吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            _this.loading.state = true;
            _this.approvalExportManageService.approvalMessageExport(exportModel, _this.loading)
                .subscribe(function (data) {
                _this.$message.success('导出成功'), _this.refreshData();
            }, function (err) { });
        })
            .catch(function () { });
    };
    //案件导入
    ReportcaseManage.prototype.importCase = function () {
        this.dialog.caseImport = true;
    };
    __decorate([
        Dependencies(PageService)
    ], ReportcaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(ApprovalExportManageService)
    ], ReportcaseManage.prototype, "approvalExportManageService", void 0);
    ReportcaseManage = __decorate([
        Layout('workspace'),
        Component({
            components: {
                FollowRecord: FollowRecord,
                DataForm: DataForm,
                DataBox: DataBox,
                ReportcaseManagePending: ReportcaseManagePending,
                ReportcaseManageResolve: ReportcaseManageResolve,
                ReportcaseManageHandled: ReportcaseManageHandled,
                ProcessApprove: ProcessApprove,
                AddNote: AddNote,
                CheckNote: CheckNote,
                CommonFileUpload: CommonFileUpload,
                PrincipalBatch: PrincipalBatch
            },
        })
    ], ReportcaseManage);
    return ReportcaseManage;
}(Vue));
export default ReportcaseManage;
